import React from 'react';
import styles from './styles/Loginbutton.module.css';
import { Link } from 'react-router-dom';

const Loginbutton = ({ name }) => {
  return <Link to="/login"><button className={styles.bttn}>{name}</button></Link>;
};

export default Loginbutton;
